var React = require('react');
var cookie = require('react-cookie');

if (process.env.BROWSER) {
  require('../assets/css/facebook.css');
}

module.exports = React.createClass({

  render: function() {
    return (
      <div>
        <div className={ this.props.class ? this.props.class : 'facebook social-login' } onClick={ this.handleClick }>
        </div>
        <div id="fb-root"></div>
      </div>
    )
  },

  componentDidMount: function() {

    window.fbAsyncInit = function() {
      FB.init({
        appId: 594973660678399,
        xfbml: true,
        version: 'v2.6'
      });

      if (this.props.autoLoad) {

        FB.getLoginStatus(function(response) {
          this.checkLoginState(response);
        }.bind(this));

      }

    }.bind(this);

    // Load the SDK asynchronously
    (function(d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = "//connect.facebook.net/pt_BR/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
  },

  responseApi: function(authResponse) {
    FB.api('/me?fields=id,name,email,permissions', function(response) {

      response.status = 'connected';
      response.accessToken = authResponse.accessToken;
      response.expiresIn = authResponse.expiresIn;
      response.signedRequest = authResponse.signedRequest;

      if (this.props.loginHandler) {
        this.props.loginHandler(response);
      }


    }.bind(this));
  },

  checkLoginState: function(response) {
    if (response.authResponse) {

      this.responseApi(response.authResponse);

    } else {

      if (this.props.loginHandler) {
        this.props.loginHandler({
          status: response.status
        });

      }

    }
  },

  handleClick: function() {
    var valueScope = this.props.scope || 'public_profile, email';
    FB.login(this.checkLoginState, {
      scope: valueScope
    });
  }
});


// WEBPACK FOOTER //
// ./src/components/Facebook.js